import BaseServiceHttp from '../baseService'
class Jasper extends BaseServiceHttp {
  constructor(id) {
    const resource = 'relatorios/jasper'
    const relationship = {
      ProcessaLeituras: 'gestao-leitura/processa-leituras',
      QrCode: 'cartao-livro'
    }
    const baseURL = process.env.REACT_APP_API_URL
    super(id, resource, relationship, baseURL)
  }

  get(filter) {
    return this._http.get(
      'https://apps.viacometa.com.br/api/leitura/relatorios/jasper/cartao-livro',
      {
        params: filter,
        responseType: 'blob'
      }
    )
  }
}

export default id => new Jasper(id)
